
import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
  List,
  ListItem,
  ListItemText,
  Radio,
  RadioGroup
} from '@mui/material';
import useReportsData from "../hooks/useReportsData";
import { ContactSupportOutlined } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import loanfundRoute from 'app/views/loanfund/loanfund-routes';
import MonthlyActivityReport from './MonthlyActivityReport';
import PaymentStatusReport from './PaymentStatusReport';
import { getAllActivityType } from "../../loanactivity/Service";

const FilterReports = ({ }) => {


  const loadScript = (src) => {
    return new Promise((resolve, reject) => {
      // Check if script is already loaded
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => {
        console.log(`${src} loaded`);
        resolve();
      };
      script.onerror = (e) => {
        console.error(`Failed to load script ${src}`, e);
        reject(new Error(`Failed to load script: ${src}`));
      };
      document.body.appendChild(script);
    });
  };


  const waitForStimulsoft = async () => {
    if (window.Stimulsoft?.Viewer) {
      console.log('Stimulsoft already loaded');
      return window.Stimulsoft;
    }

    console.log('Loading Stimulsoft scripts...');
    await loadScript('/stimulsoft/stimulsoft.reports.js');
    await loadScript('/stimulsoft/stimulsoft.viewer.js');

    if (!window.Stimulsoft?.Viewer) {
      throw new Error('Stimulsoft failed to load properly.');
    }

    window.Stimulsoft.Base.StiLicense.key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHk8RHJ6YukLSxFNxOsGywCmSfDmNx54ijoADYy8ZbVyM2jfqO" +
      "XKdON4rOS1c4pYt+vz3OZj2h5NQ5xt1EHgsdxT9FLudqeHLONw2Ilz5GFCADtzxp1LJgZzdOKAPwaCt2pKcALM8JCu" +
      "oSWTXhL6pSipVdAC3kmr4l/bdrNhEmf4ARCRcv8Je5e5c2/Jjol0t8ey/O5HrlXlz+EC2Cz4Dx66o6WvwzDMBv56zd" +
      "3cSiUMqyw5J9NVd3Dkk09nWGDipivUFGdO6p0xGmG+mXDOC+aap+URaMm3DKj2kWRXguqTyadS7r718J6UNqnuH5fG" +
      "/U0fnt5FumYLZmz+sPlmEo4tu3tDnAhGKcDj+ZIMG6h2YPo49FKTI/xrGWxUpVdA2z/1XqMN/LzY6eVUxOfLMuFNsZ" +
      "9anqLes7Xr5v3I2YWIfLeq60bMG0UbFYV0s7C7ybmH9Kvdnt7ddUbP0CWtZLNnbDxbRMayRP9ntwdQibsT5x6wJKA2" +
      "NPA7vDQwiKBmPVzZpBABwAAjeeztmBdxD/Rd";

    console.log('Stimulsoft loaded and license applied.');

    setTimeout(() => {
      console.log('License key:', window.Stimulsoft.Base.StiLicense.key);
      console.log('License status:', window.Stimulsoft.Base.StiLicense.status);
    }, 1000);
    return window.Stimulsoft;
  };

  const renderStimulsoftViewer = async (apiResponse) => {
    const Stimulsoft = await waitForStimulsoft();

    Stimulsoft.Base.StiLicense.key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHk8RHJ6YukLSxFNxOsGywCmSfDmNx54ijoADYy8ZbVyM2jfqO" +
      "XKdON4rOS1c4pYt+vz3OZj2h5NQ5xt1EHgsdxT9FLudqeHLONw2Ilz5GFCADtzxp1LJgZzdOKAPwaCt2pKcALM8JCu" +
      "oSWTXhL6pSipVdAC3kmr4l/bdrNhEmf4ARCRcv8Je5e5c2/Jjol0t8ey/O5HrlXlz+EC2Cz4Dx66o6WvwzDMBv56zd" +
      "3cSiUMqyw5J9NVd3Dkk09nWGDipivUFGdO6p0xGmG+mXDOC+aap+URaMm3DKj2kWRXguqTyadS7r718J6UNqnuH5fG" +
      "/U0fnt5FumYLZmz+sPlmEo4tu3tDnAhGKcDj+ZIMG6h2YPo49FKTI/xrGWxUpVdA2z/1XqMN/LzY6eVUxOfLMuFNsZ" +
      "9anqLes7Xr5v3I2YWIfLeq60bMG0UbFYV0s7C7ybmH9Kvdnt7ddUbP0CWtZLNnbDxbRMayRP9ntwdQibsT5x6wJKA2" +
      "NPA7vDQwiKBmPVzZpBABwAAjeeztmBdxD/Rd";

    const payload = typeof apiResponse === "string"
      ? JSON.parse(apiResponse)
      : apiResponse;

    const dataSources = payload.data || {};


    const report = new Stimulsoft.Report.StiReport();
    report.load(payload.template);

    // Hide parameter panel.
    for (let i = 0; i < report.dictionary.variables.count; i++) {
      report.dictionary.variables.getByIndex(i).requestFromUser = false;
    }

    report.dictionary.databases.clear();
    report.dictionary.dataSources.clear();

    const dataSet = new Stimulsoft.System.Data.DataSet();
    dataSet.readJson(dataSources);

    report.regData("JsonData", "JsonData", dataSet);
    report.dictionary.synchronize();

    const options = new Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.showBranding = false;
    options.appearance.showAboutButton = false;
    options.toolbar.showParametersButton = false;

    const viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);

    report.renderAsync(() => {
      viewer.report = report;
      viewer.renderHtml("viewerContent");
    });
  };


  const {
    loannums,
    citys,
    loanofficers,
    reportNames,
    borrowerTypeList,
    countys,
    loanTypes,
    loanStatusList,
    fundSources,
    fetchReportData,
  } = useReportsData();

  const monthlyActivityReportRef = useRef();
  const paymentStatusReportRef = useRef();

  const [reportName, setReportName] = useState('Master File Report');
  const [cutoffDate, setCutoffDate] = useState(new Date().toISOString().split('T')[0]);
  const [loanFrom, setLoanFrom] = useState('');
  const [loanTo, setLoanTo] = useState('');
  const [sortOption, setSortOption] = useState('# Loan Number');
  const [reportType, setReportType] = useState('Detail');
  const [includeFID, setIncludeFID] = useState(false);
  const [includeNotes, setIncludeNotes] = useState(true);
  const [selectedFunds, setSelectedFunds] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedLoanOfficer, setSelectedLoanOfficer] = useState([]);
  const [selectedLoanType, setSelectedLoanType] = useState([]);
  const [selectedBorrower, setSelectedBorrower] = useState([]);
  const [includeAllActivityTypes, setIncludeAllActivityTypes] = useState(true);
  const [activityTypes, setActivityTypes] = useState([]);
  const [selectedActivityType, setSelectedActivityType] = useState('All');
  const [tabValue, setTabValue] = useState(0);
  const [showViewer, setShowViewer] = useState(false);

  const [selectedReportType, setSelectedReportType] = useState('D');
  const [sortBy, setSortBy] = useState('Date');
  const [includeAllDates, setIncludeAllDates] = useState(true);
  const [dateFrom, setDateFrom] = useState('2025-06-23');
  const [dateTo, setDateTo] = useState('2025-06-23');
  const [includeAllFunds, setIncludeAllFunds] = useState(true);
  const [endingDate, setEndingDate] = useState('2025-06-23');
  const [includeNonCash, setIncludeNonCash] = useState(false);

  const [tabIndex, setTabIndex] = useState(0);
  const [postingDate, setPostingDate] = useState(new Date());

  // State for Monthly Activity Report
  const [beginDate, setBeginDate] = useState(new Date().toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [monthlyLoanFrom, setMonthlyLoanFrom] = useState('');
  const [monthlyLoanTo, setMonthlyLoanTo] = useState('');
  const [monthlyReportType, setMonthlyReportType] = useState('Detail');
  const [monthlySortOption, setMonthlySortOption] = useState('# Loan Number');
  const [monthlyActivityType, setMonthlyActivityType] = useState('All');
  const [includeNonCashActivity, setIncludeNonCashActivity] = useState(false);
  const [monthlySelectedFunds, setMonthlySelectedFunds] = useState([]);
  const [monthlySelectedCounty, setMonthlySelectedCounty] = useState([]);
  const [monthlySelectedCity, setMonthlySelectedCity] = useState([]);
  const [monthlySelectedStatus, setMonthlySelectedStatus] = useState([]);
  const [monthlySelectedLoanOfficer, setMonthlySelectedLoanOfficer] = useState([]);
  const [monthlySelectedLoanType, setMonthlySelectedLoanType] = useState([]);
  const [monthlySelectedBorrower, setMonthlySelectedBorrower] = useState([]);
  const [monthlyTabValue, setMonthlyTabValue] = useState(0);

  // State for Payment Status Report
  const [paymentCutoffDate, setPaymentCutoffDate] = useState(new Date().toISOString().split('T')[0]);
  const [paymentLoanFrom, setPaymentLoanFrom] = useState('');
  const [paymentLoanTo, setPaymentLoanTo] = useState('');
  const [paymentSortOption, setPaymentSortOption] = useState('# Loan Number');
  const [paymentSelectedFunds, setPaymentSelectedFunds] = useState([]);
  const [paymentSelectedCounty, setPaymentSelectedCounty] = useState([]);
  const [paymentSelectedCity, setPaymentSelectedCity] = useState([]);
  const [paymentSelectedStatus, setPaymentSelectedStatus] = useState([]);
  const [paymentSelectedLoanOfficer, setPaymentSelectedLoanOfficer] = useState([]);
  const [paymentSelectedLoanType, setPaymentSelectedLoanType] = useState([]);
  const [paymentSelectedBorrower, setPaymentSelectedBorrower] = useState([]);
  const [paymentTabValue, setPaymentTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const journalRows = [
    { id: 1, batch: 14, period: '07/21', je: 14, date: '7/4/2021', gjBatch: 33, gj: 68 },
    { id: 2, batch: 13, period: '06/21', je: 13, date: '6/6/2021', gjBatch: 32, gj: 67 },
    { id: 3, batch: 12, period: '05/21', je: 12, date: '6/6/2021', gjBatch: 31, gj: 66 },
    { id: 4, batch: 11, period: '04/21', je: 11, date: '5/9/2021', gjBatch: 30, gj: 65 },
    { id: 5, batch: 10, period: '03/21', je: 10, date: '4/3/2021', gjBatch: 29, gj: 64 },
    { id: 6, batch: 9, period: '02/21', je: 9, date: '3/6/2021', gjBatch: 28, gj: 63 },
    { id: 7, batch: 8, period: '01/21', je: 8, date: '2/8/2021', gjBatch: 27, gj: 62 },
    { id: 8, batch: 7, period: '12/20', je: 7, date: '1/4/2021', gjBatch: 26, gj: 61 },
    { id: 9, batch: 6, period: '11/20', je: 6, date: '12/6/2020', gjBatch: 25, gj: 60 },
    { id: 10, batch: 5, period: '10/20', je: 5, date: '11/5/2020', gjBatch: 24, gj: 59 },
    { id: 11, batch: 4, period: '09/20', je: 4, date: '10/6/2020', gjBatch: 23, gj: 58 },
    { id: 12, batch: 3, period: '08/20', je: 3, date: '9/7/2020', gjBatch: 22, gj: 57 },
    { id: 13, batch: 2, period: '07/20', je: 2, date: '8/6/2020', gjBatch: 21, gj: 56 },
    { id: 14, batch: 1, period: '06/20', je: 1, date: '7/5/2020', gjBatch: 20, gj: 55 },
  ];

  const journalColumns = [
    { field: 'batch', headerName: 'Batch', width: 100 },
    { field: 'period', headerName: 'Period', width: 100 },
    { field: 'je', headerName: 'JE', width: 100 },
    { field: 'date', headerName: 'AccountingDate', width: 150 },
    { field: 'gjBatch', headerName: 'GJBatchNumber', width: 150 },
    { field: 'gj', headerName: 'GJ', width: 100 },
  ];


  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div role="tabpanel" hidden={value !== index} {...other}>
        {value === index && <Box p={2}>{children}</Box>}
      </div>
    );
  }

  // Parse report names from API (handles both string[] and object[] shapes)
  const reportNameOptions = Array.isArray(reportNames)
    ? reportNames
      .map((rn) => (typeof rn === 'string' ? rn : rn?.name || rn?.Name))
      .filter(Boolean)
    : [];

  // Fallback list if API hasn't loaded yet or returns empty
  const defaultReportList = [
    'Master File Report',
    'Activity Report',
    'Master File Both',
    'Aging Report',
    'Current Non-Current Balance',
    'Accured Interest Analysis',
    'Analysis by Fund',
    'Borrower Profiles',
    'Monthly Activity Report',
    'Payment Status Report'
  ];

  const displayReportOptions = reportNameOptions.length > 0 ? reportNameOptions : defaultReportList;

  const fundOptions = fundSources.map(fs => fs.code + ' ' + fs.description);
  const sortOptions = ['A  Alphabetical', '# Loan Number', '$ Loan Amount', 'Loan Officer', 'Payment Due Date'];
  const reportTypes = ['Detail', 'Summary', 'Principal', 'Interest', 'Repayment', 'Balance', 'Master File Report', 'Activity Report', 'Master File Both', 'Multiple Borrower List', 'Master File Report', 'Activity Report', 'Both'];
  const countyOptions = countys.map(c => c.county);//['Hennepin', 'Ramsey', 'Dakota'];
  //const cityOptions = ['Minneapolis', 'St. Paul', 'Bloomington'];
  const cityNames = citys.map(c => c.city);
  const statusOptions = loanStatusList.map(ls => ls.statusCode); //['Active', 'Closed', 'Delinquent'];
  const loanOfficerOptions = loanofficers.map(lo => lo.loanOfficer);//['John Smith', 'Jane Doe', 'Alice Johnson'];
  const loanTypeOptions = loanTypes.map(lt => lt.code + ' ' + lt.description);//['Personal', 'Business', 'Auto'];
  const borrowerOptions = borrowerTypeList.map(b => b.code + ' ' + b.description); //['Borrower A', 'Borrower B', 'Borrower C'];

  const isJournalReport = reportName === 'Journal Entry';
  const isMonthlyActivityReport = reportName === 'Monthly Activity Report';
  const isPaymentStatusReport = reportName === 'Payment Status Report';
  const isActivityReport = reportName === 'Activity Report';

  // Fetch activity types on component mount
  useEffect(() => {
    const fetchActivityTypes = async () => {
      try {
        const response = await getAllActivityType();
        console.log('Activity Types API Response:', response);

        let apiActivityTypes = [];
        if (response.data) {
          apiActivityTypes = Array.isArray(response.data)
            ? response.data
            : (response.data.activityTypes || []);
        }

        console.log('Parsed Activity Types:', apiActivityTypes);

        const activityTypeOptions = [
          { id: 0, activityTypeName: 'All' },
          ...apiActivityTypes
        ];

        setActivityTypes(activityTypeOptions);
      } catch (error) {
        console.error('Failed to fetch activity types', error);
        setActivityTypes([{ id: 0, activityTypeName: 'All' }]);
      }
    };

    fetchActivityTypes();
  }, []);

  useEffect(() => {
    // Don't auto-select loan range for Activity Report, Monthly Activity Report, Payment Status Report, Master File Report, or Master File Both
    const reportsWithoutAutoSelect = ['Activity Report', 'Monthly Activity Report', 'Payment Status Report', 'Master File Report', 'Master File Both'];

    if (loannums.length > 0 && loanFrom === '' && !reportsWithoutAutoSelect.includes(reportName)) {
      console.log('First loan ID:', loannums[0].loanNumber);
      setLoanFrom(loannums[0].id);
      setLoanTo(loannums[loannums.length - 1].id);
    }

  }, [loannums, reportName]);

  // When switching to Master File reports, ensure default sort is Loan Number
  useEffect(() => {
    const masterFileReports = ['Master File Report', 'Master File Both', 'Master Files'];
    if (masterFileReports.includes(reportName) && sortOption !== '# Loan Number') {
      setSortOption('# Loan Number');
    }
  }, [reportName]);

  // Clear loan selections when switching to reports that don't need auto-selection
  useEffect(() => {
    const reportsWithoutAutoSelect = ['Activity Report', 'Monthly Activity Report', 'Payment Status Report', 'Master File Report', 'Master File Both'];
    if (reportsWithoutAutoSelect.includes(reportName)) {
      setLoanFrom('');
      setLoanTo('');
    }
  }, [reportName]);

  // Sync reportName with API loaded names if current value isn't available
  useEffect(() => {
    if (displayReportOptions.length > 0 && !displayReportOptions.includes(reportName)) {
      // Try to default to Master File Report, otherwise pick first available
      const defaultReport = displayReportOptions.includes('Master File Report')
        ? 'Master File Report'
        : displayReportOptions[0];
      setReportName(defaultReport);
    }
  }, [reportNames]);

  const handleListSelectionChange = (value, list, setList) => {
    if (list.includes(value)) {
      setList(list.filter(item => item !== value));
    } else {
      setList([...list, value]);
    }
  };

  const handleGenerate = async () => {
    setShowViewer(true); // Hides filter and shows viewer
    console.log('=== Generate Report Started ===');
    console.log('Loan Numbers:', loannums);

    const payload = {
      reportName,
      cutoffDate,
      loanFrom: parseInt(loannums.find(x => x.id === loanFrom)?.loanNumber ?? "0"),
      loanTo: parseInt(loannums.find(x => x.id === loanTo)?.loanNumber ?? "0"),
      sortOption,
      reportType,
      includeFID,
      includeNotes,
      selectedFunds,
      selectedCounty,
      selectedCity,
      selectedStatus,
      selectedLoanOfficer,
      selectedLoanType,
      selectedBorrower,
      includeAllActivityTypes,
      activityType: selectedActivityType,
      tabValue,
      showViewer: true, // Always true when generating
      loanMasterId: 0, // Default for filtered reports
      loanActivityId: 0 // Default for filtered reports
    };

    console.log('API Payload:', JSON.stringify(payload, null, 2));

    try {
      const reportdata = await fetchReportData(payload);
      console.log('Report data received, length:', reportdata?.length || 0);
      const jsonReport = reportdata;
      await renderStimulsoftViewer(jsonReport);
    } catch (error) {
      console.error('Error generating report:', error);
      alert('Failed to generate report. Check console for details.');
      setShowViewer(false);
    }
  };

  const handleMonthlyActivityReportGenerate = async (payload) => {
    setShowViewer(true);
    console.log('=== Monthly Activity Report Generate Started ===');
    console.log('Payload:', payload);

    try {
      const reportdata = await fetchReportData(payload);
      console.log('Report data received, length:', reportdata?.length || 0);
      await renderStimulsoftViewer(reportdata);
    } catch (error) {
      console.error('Error generating Monthly Activity Report:', error);
      alert('Failed to generate report. Check console for details.');
      setShowViewer(false);
    }
  };


  const tabPanels = [
    { label: 'Funds', options: fundOptions, selected: selectedFunds, setSelected: setSelectedFunds },
    { label: 'County', options: countyOptions, selected: selectedCounty, setSelected: setSelectedCounty },
    { label: 'City', options: cityNames, selected: selectedCity, setSelected: setSelectedCity },
    { label: 'Status', options: statusOptions, selected: selectedStatus, setSelected: setSelectedStatus },
    { label: 'Loan Officer', options: loanOfficerOptions, selected: selectedLoanOfficer, setSelected: setSelectedLoanOfficer },
    { label: 'Loan Type', options: loanTypeOptions, selected: selectedLoanType, setSelected: setSelectedLoanType },
    { label: 'Borrower', options: borrowerOptions, selected: selectedBorrower, setSelected: setSelectedBorrower },
  ];


  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        p: 2,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <Card>
        <CardContent>

          {isMonthlyActivityReport && (
            <Box display="flex" flexDirection="column" gap={2}>
              {!showViewer ? (
                <Box sx={{ maxWidth: 800, mx: 'auto', p: 2 }}>
                  <Box display="flex" gap={2} mb={2}>
                    <FormControl fullWidth>
                      <InputLabel>Report Name</InputLabel>
                      <Select
                        value={reportName}
                        onChange={e => setReportName(e.target.value)}
                        label="Report Name"
                      >
                        {displayReportOptions.map((name, idx) => (
                          <MenuItem key={idx} value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <MonthlyActivityReport
                    ref={monthlyActivityReportRef}
                    onGenerate={handleMonthlyActivityReportGenerate}
                    beginDate={beginDate}
                    setBeginDate={setBeginDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    loanFrom={monthlyLoanFrom}
                    setLoanFrom={setMonthlyLoanFrom}
                    loanTo={monthlyLoanTo}
                    setLoanTo={setMonthlyLoanTo}
                    reportType={monthlyReportType}
                    setReportType={setMonthlyReportType}
                    sortOption={monthlySortOption}
                    setSortOption={setMonthlySortOption}
                    selectedActivityType={monthlyActivityType}
                    setSelectedActivityType={setMonthlyActivityType}
                    tabValue={monthlyTabValue}
                    setTabValue={setMonthlyTabValue}
                    includeNonCashActivity={includeNonCashActivity}
                    setIncludeNonCashActivity={setIncludeNonCashActivity}
                    selectedFunds={monthlySelectedFunds}
                    setSelectedFunds={setMonthlySelectedFunds}
                    selectedCounty={monthlySelectedCounty}
                    setSelectedCounty={setMonthlySelectedCounty}
                    selectedCity={monthlySelectedCity}
                    setSelectedCity={setMonthlySelectedCity}
                    selectedStatus={monthlySelectedStatus}
                    setSelectedStatus={setMonthlySelectedStatus}
                    selectedLoanOfficer={monthlySelectedLoanOfficer}
                    setSelectedLoanOfficer={setMonthlySelectedLoanOfficer}
                    selectedLoanType={monthlySelectedLoanType}
                    setSelectedLoanType={setMonthlySelectedLoanType}
                    selectedBorrower={monthlySelectedBorrower}
                    setSelectedBorrower={setMonthlySelectedBorrower}
                  />
                </Box>
              ) : (
                <Box>
                  <Box
                    id="viewerContent"
                    sx={{
                      flexGrow: 1,
                      overflow: 'auto',
                      mx: 'auto',
                      my: 2,
                      width: '100%',
                    }}
                  />
                  <Box sx={{ textAlign: 'center', mt: 2 }}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        setShowViewer(false);
                        const viewerElement = document.getElementById('viewerContent');
                        if (viewerElement) viewerElement.innerHTML = '';
                      }}
                    >
                      Close
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          )}
          {isPaymentStatusReport && (
            <Box display="flex" flexDirection="column" gap={2}>
              {!showViewer ? (
                <Box sx={{ maxWidth: 800, mx: 'auto', p: 2 }}>
                  <Box display="flex" gap={2} mb={2}>
                    <FormControl fullWidth>
                      <InputLabel>Report Name</InputLabel>
                      <Select
                        value={reportName}
                        onChange={e => setReportName(e.target.value)}
                        label="Report Name"
                      >
                        {displayReportOptions.map((name, idx) => (
                          <MenuItem key={idx} value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <PaymentStatusReport
                    ref={paymentStatusReportRef}
                    onGenerate={handleMonthlyActivityReportGenerate}
                    cutoffDate={paymentCutoffDate}
                    setCutoffDate={setPaymentCutoffDate}
                    loanFrom={paymentLoanFrom}
                    setLoanFrom={setPaymentLoanFrom}
                    loanTo={paymentLoanTo}
                    setLoanTo={setPaymentLoanTo}
                    sortOption={paymentSortOption}
                    setSortOption={setPaymentSortOption}
                    tabValue={paymentTabValue}
                    setTabValue={setPaymentTabValue}
                    selectedFunds={paymentSelectedFunds}
                    setSelectedFunds={setPaymentSelectedFunds}
                    selectedCounty={paymentSelectedCounty}
                    setSelectedCounty={setPaymentSelectedCounty}
                    selectedCity={paymentSelectedCity}
                    setSelectedCity={setPaymentSelectedCity}
                    selectedStatus={paymentSelectedStatus}
                    setSelectedStatus={setPaymentSelectedStatus}
                    selectedLoanOfficer={paymentSelectedLoanOfficer}
                    setSelectedLoanOfficer={setPaymentSelectedLoanOfficer}
                    selectedLoanType={paymentSelectedLoanType}
                    setSelectedLoanType={setPaymentSelectedLoanType}
                    selectedBorrower={paymentSelectedBorrower}
                    setSelectedBorrower={setPaymentSelectedBorrower}
                  />
                </Box>
              ) : (
                <Box>
                  <Box
                    id="viewerContent"
                    sx={{
                      flexGrow: 1,
                      overflow: 'auto',
                      mx: 'auto',
                      my: 2,
                      width: '100%',
                    }}
                  />
                  <Box sx={{ textAlign: 'center', mt: 2 }}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        setShowViewer(false);
                        const viewerElement = document.getElementById('viewerContent');
                        if (viewerElement) viewerElement.innerHTML = '';
                      }}
                    >
                      Close
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          )}
          {!isMonthlyActivityReport && !isPaymentStatusReport && !isJournalReport && (
            <Box display="flex" flexDirection="column" gap={2}>
              {!showViewer ? (
                <Box sx={{ maxWidth: 800, mx: 'auto', p: 2 }}>
                  <Box display="flex" gap={2} mb={2}>
                    <FormControl fullWidth>
                      <InputLabel>Report Name</InputLabel>
                      <Select
                        value={reportName}
                        onChange={e => setReportName(e.target.value)}
                        label="Report Name"
                      >
                        {displayReportOptions.map((name, idx) => (
                          <MenuItem key={idx} value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  {reportName !== 'Master File Report' && (
                    <Box display="flex" gap={2} mb={2}>
                      <TextField
                        label="Cutoff Date"
                        type="date"
                        value={cutoffDate}
                        onChange={e => setCutoffDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Box>
                  )}
                  <Box display="flex" gap={2} mb={2}>
                    <FormControl fullWidth>
                      <InputLabel>Loan From</InputLabel>
                      <Select
                        value={loanFrom}
                        onChange={e => setLoanFrom(e.target.value)}
                        label="Loan From"
                      >
                        {loannums.map((loannum) => (
                          <MenuItem key={loannum.id} value={loannum.id}>
                            {loannum.loanNumber} {loannum.loanName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>Loan To</InputLabel>
                      <Select
                        value={loanTo}
                        onChange={e => setLoanTo(e.target.value)}
                        label="Loan To"
                      >
                        {loannums.map((loannum) => (
                          <MenuItem key={loannum.id} value={loannum.id}>
                            {loannum.loanNumber} {loannum.loanName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box display="flex" gap={2} mb={2}>
                    <FormControl fullWidth>
                      <InputLabel>Sort Options</InputLabel>
                      <Select value={sortOption} onChange={e => setSortOption(e.target.value)} label="Sort Options">
                        {sortOptions.map((sortoption) => (
                          <MenuItem key={sortoption} value={sortoption}>
                            {sortoption}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      {/* <InputLabel>Report Type</InputLabel>
                      <Select value={reportType} onChange={e => setReportType(e.target.value)} label="Report Type">
                        {reportTypes.map((reporttype) => (
                          <MenuItem key={reporttype} value={reporttype}>
                            {reporttype}
                          </MenuItem>
                        ))}
                      </Select> */}
                    </FormControl>
                  </Box>

                  {(isActivityReport || ['Master File Both', 'Master Files'].includes(reportName)) && (
                    <Box display="flex" gap={2} mb={2}>
                      <FormControl fullWidth>
                        <InputLabel>Activity Type</InputLabel>
                        <Select
                          value={selectedActivityType}
                          onChange={e => setSelectedActivityType(e.target.value)}
                          label="Activity Type"
                        >
                          {activityTypes.map((activityType) => (
                            <MenuItem key={activityType.id} value={activityType.activityTypeName || activityType.name || 'All'}>
                              {activityType.activityTypeName || activityType.name || 'All'}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )}

                  {reportName === 'Activity Report' ? (
                    <Box display="flex" gap={2} mb={2}>
                      <FormControlLabel
                        control={<Checkbox checked={includeNotes} onChange={e => setIncludeNotes(e.target.checked)} />}
                        label="Include Notes"
                      />
                    </Box>
                  ) : reportName === 'Master File Report' ? (
                    <Box display="flex" gap={2} mb={2}>
                      <FormControlLabel
                        control={<Checkbox checked={includeFID} onChange={e => setIncludeFID(e.target.checked)} />}
                        label="Include FID/SSN"
                      />
                    </Box>
                  ) : ['Master File Both', 'Master Files'].includes(reportName) ? (
                    <Box display="flex" gap={2} mb={2}>
                      <FormControlLabel
                        control={<Checkbox checked={includeNotes} onChange={e => setIncludeNotes(e.target.checked)} />}
                        label="Include Notes"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={includeFID} onChange={e => setIncludeFID(e.target.checked)} />}
                        label="Include FID/SSN"
                      />
                    </Box>
                  ) : (
                    <Box display="flex" gap={2} mb={2}>
                      <FormControlLabel
                        control={<Checkbox checked={includeFID} onChange={e => setIncludeFID(e.target.checked)} />}
                        label="Include Active $0.00 Balance Loans"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={includeNotes} onChange={e => setIncludeNotes(e.target.checked)} />}
                        label="Include Borrower Name"
                      />
                    </Box>
                  )}

                  <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
                    {tabPanels.map((tab, idx) => <Tab key={idx} label={tab.label} />)}
                  </Tabs>

                  <Box mt={2} sx={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #ccc', borderRadius: 1, p: 1 }}>
                    <List>
                      {tabPanels[tabValue].options.map((option, index) => (
                        <ListItem
                          key={index}
                          button
                          onClick={() => handleListSelectionChange(option, tabPanels[tabValue].selected, tabPanels[tabValue].setSelected)}
                          selected={tabPanels[tabValue].selected.includes(option)}
                        >
                          <ListItemText
                            primary={option}
                            secondary={tabPanels[tabValue].selected.includes(option) ? 'Selected' : ''}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>

                  {reportName !== 'Master File Report' && reportName !== 'Activity Report' && !['Master File Both', 'Master Files'].includes(reportName) && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={includeAllActivityTypes}
                          onChange={e => setIncludeAllActivityTypes(e.target.checked)}
                        />
                      }
                      label="Include All Activity Types"
                    />
                  )}

                  {/* <Box mt={2}>
                        <Button variant="contained" onClick={handleGenerate}>Generate</Button>
                      </Box> */}

                </Box>
              ) : (
                <Box>
                  <Box
                    id="viewerContent"
                    sx={{
                      flexGrow: 1,
                      overflow: 'auto',
                      // border: '1px solid #ccc',
                      // borderRadius: 1,
                      mx: 'auto',
                      my: 2,
                      width: '100%',
                    }}
                  />
                  <Box sx={{ textAlign: 'center', mt: 2 }}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        setShowViewer(false);
                        const viewerElement = document.getElementById('viewerContent');
                        if (viewerElement) viewerElement.innerHTML = '';
                      }}
                    >
                      Close
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          )}
          {isJournalReport && (
            <Box display="flex" flexDirection="column" gap={2}>
              {!showViewer ? (
                <Box sx={{ maxWidth: 800, mx: 'auto', p: 2 }}>
                  <Box display="flex" gap={2} mb={2}>
                    <FormControl fullWidth>
                      <InputLabel>Report Name</InputLabel>
                      <Select
                        value={reportName}
                        onChange={e => setReportName(e.target.value)}
                        label="Report Name"
                      >
                        {displayReportOptions.map((name, idx) => (
                          <MenuItem key={idx} value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ width: '100%' }}>
                    <Tabs value={tabIndex} onChange={handleTabChange}>
                      <Tab label="Journal Entry" />
                      <Tab label="Journal Entry List" />
                      <Tab label="Setup Journal Entry" />
                    </Tabs>

                    {/* --- Tab 1: Journal Entry Form --- */}
                    <TabPanel value={tabIndex} index={0}>
                      <Box sx={{ display: 'flex', gap: 2, mb: 3, textAlign: 'center' }}>
                        <TextField label="Activity Period" defaultValue="01/21" disabled />
                        <TextField label="Batch #" defaultValue="8" />
                        <TextField label="Journal Entry #" defaultValue="8" />
                      </Box>
                      <Box sx={{ border: '1px solid #ccc', p: 2, borderRadius: 2, width: 700 }}>
                        <Typography variant="subtitle1" gutterBottom>
                          Send Journal Entry to Accounting System
                        </Typography>
                        <TextField
                          select
                          label="Accounting Database"
                          fullWidth
                          defaultValue="convert.net"
                          sx={{ mb: 2 }}
                        >
                          <MenuItem value="convert.net">convert.net</MenuItem>
                        </TextField>

                        <Box display="flex" flexDirection="column" gap={2}>
                          <TextField
                            label="Posting Period"
                            type="date"
                            value={postingDate}
                            onChange={e => setPostingDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                          />
                          <Button variant="contained">
                            Send
                          </Button>
                        </Box>
                      </Box>
                    </TabPanel>

                    {/* --- Tab 2: Journal Entry List --- */}
                    <TabPanel value={tabIndex} index={1}>
                      <Box sx={{ height: 500 }}>
                        <DataGrid
                          rows={journalRows}
                          columns={journalColumns}
                          pageSize={10}
                          rowsPerPageOptions={[10]}
                        />
                      </Box>
                    </TabPanel>
                  </Box>
                </Box>
              ) : (
                <Box>
                  <Box
                    id="viewerContent"
                    sx={{
                      flexGrow: 1,
                      overflow: 'auto',
                      mx: 'auto',
                      my: 2,
                      width: '100%',
                    }}
                  />
                  <Box sx={{ textAlign: 'center', mt: 2 }}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        setShowViewer(false);
                        const viewerElement = document.getElementById('viewerContent');
                        if (viewerElement) viewerElement.innerHTML = '';
                      }}
                    >
                      Close
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          )}

          {!showViewer && (
            <Box sx={{ maxWidth: 710, mx: 'auto', mb: 2, textAlign: 'center' }}>
              <Button
                variant="contained"
                onClick={
                  isMonthlyActivityReport
                    ? () => monthlyActivityReportRef.current?.generateReport()
                    : isPaymentStatusReport
                      ? () => paymentStatusReportRef.current?.generateReport()
                      : handleGenerate
                }
              >
                Generate
              </Button>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default FilterReports;